/*
 *
 * Package: `@dbh/design-showcase-page`.
 *
 */const importDesignShowCasePage=()=>import('./component-9cfc7dad.js'/*  webpackChunkName: 'dbh.design-showcase-page.component' */).then(function (n) { return n.d; });// to avoid the exported code leaking into other pages and increasing the bundle
// size unappropriately.

export { importDesignShowCasePage as default };
